var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3, _g, _g2, _g3, _circle, _circle2, _g4, _g5, _circle3, _circle4, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaitUntilNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 90,
    viewBox: "0 0 206 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_933_11603)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#137FFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.9997 17.9974L63.5754 16.8105C63.3638 16.6341 63.258 16.546 63.1819 16.4379C63.1145 16.3421 63.0644 16.2352 63.034 16.1222C62.9997 15.9945 62.9997 15.8568 62.9997 15.5813V14.6641M64.9997 17.9974L66.424 16.8105C66.6356 16.6341 66.7414 16.546 66.8175 16.4379C66.8849 16.3421 66.9349 16.2352 66.9653 16.1222C66.9997 15.9945 66.9997 15.8568 66.9997 15.5813V14.6641M64.9997 17.9974L63.5754 19.1843C63.3638 19.3607 63.258 19.4488 63.1819 19.5569C63.1145 19.6527 63.0644 19.7595 63.034 19.8726C62.9997 20.0003 62.9997 20.138 62.9997 20.4135V21.3307M64.9997 17.9974L66.424 19.1843C66.6356 19.3607 66.7414 19.4488 66.8175 19.5569C66.8849 19.6527 66.9349 19.7595 66.9653 19.8726C66.9997 20.0003 66.9997 20.138 66.9997 20.4135V21.3307M62.333 14.6641H67.6663M62.333 21.3307H67.6663",
    stroke: "#EEF9FF",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_933_11603)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 63,
    width: 85,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 69,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 73,
    width: 55,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddd_933_11603)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 63,
    width: 85,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 69,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 73,
    width: 55,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2652 63.2652C45.1187 63.4116 44.8813 63.4116 44.7348 63.2652L42.3484 60.8787C42.2019 60.7322 42.2019 60.4948 42.3484 60.3483C42.4948 60.2019 42.7322 60.2019 42.8787 60.3483L45 62.4697L47.1213 60.3483C47.2678 60.2019 47.5052 60.2019 47.6516 60.3483C47.7981 60.4948 47.7981 60.7322 47.6516 60.8787L45.2652 63.2652ZM103.375 30V31.3387H102.625V30H103.375ZM103.375 32.2312V34.9086H102.625V32.2312H103.375ZM103.375 35.8011V38.4786H102.625V35.8011H103.375ZM103.375 39.3711V40.7098H102.625V39.3711H103.375ZM103.375 40.7098C103.375 41.151 103.31 41.5776 103.188 41.98L102.47 41.7626C102.571 41.4298 102.625 41.0765 102.625 40.7098H103.375ZM102.859 42.7728C102.451 43.5343 101.825 44.1608 101.063 44.5687L100.709 43.9076C101.34 43.5695 101.86 43.0498 102.198 42.4186L102.859 42.7728ZM100.27 44.8974C99.8678 45.0193 99.4412 45.0848 99 45.0848V44.3348C99.3667 44.3348 99.7201 44.2804 100.053 44.1796L100.27 44.8974ZM99 45.0848H97.5577V44.3348H99V45.0848ZM96.5962 45.0848H93.7115V44.3348H96.5962V45.0848ZM92.75 45.0848H89.8654V44.3348H92.75V45.0848ZM88.9038 45.0848H86.0192V44.3348H88.9038V45.0848ZM85.0577 45.0848H82.1731V44.3348H85.0577V45.0848ZM81.2115 45.0848H78.3269V44.3348H81.2115V45.0848ZM77.3654 45.0848H74.4808V44.3348H77.3654V45.0848ZM73.5192 45.0848H70.6346V44.3348H73.5192V45.0848ZM69.6731 45.0848H66.7885V44.3348H69.6731V45.0848ZM65.8269 45.0848H62.9423V44.3348H65.8269V45.0848ZM61.9808 45.0848H59.0961V44.3348H61.9808V45.0848ZM58.1346 45.0848H55.25V44.3348H58.1346V45.0848ZM54.2885 45.0848H51.4038V44.3348H54.2885V45.0848ZM50.4423 45.0848H49V44.3348H50.4423V45.0848ZM49 45.0848C48.6333 45.0848 48.2799 45.1391 47.9472 45.2399L47.7297 44.5221C48.1322 44.4002 48.5588 44.3348 49 44.3348V45.0848ZM47.2911 45.5119C46.66 45.85 46.1402 46.3697 45.8022 47.0009L45.141 46.6468C45.5489 45.8852 46.1755 45.2587 46.937 44.8508L47.2911 45.5119ZM45.5301 47.657C45.4293 47.9897 45.375 48.3431 45.375 48.7098H44.625C44.625 48.2686 44.6904 47.842 44.8124 47.4395L45.5301 47.657ZM45.375 48.7098V50.0495H44.625V48.7098H45.375ZM45.375 50.9426V53.622H44.625V50.9426H45.375ZM45.375 54.5152V57.1946H44.625V54.5152H45.375ZM45.375 58.0877V60.7672H44.625V58.0877H45.375ZM45.375 61.6603V63H44.625V61.6603H45.375Z",
    fill: "#3DC3C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.735 63.2652C160.881 63.4116 161.119 63.4116 161.265 63.2652L163.652 60.8787C163.798 60.7322 163.798 60.4948 163.652 60.3483C163.505 60.2019 163.268 60.2019 163.121 60.3483L161 62.4697L158.879 60.3483C158.732 60.2019 158.495 60.2019 158.348 60.3483C158.202 60.4948 158.202 60.7322 158.348 60.8787L160.735 63.2652ZM102.625 30V31.3387H103.375V30H102.625ZM102.625 32.2312V34.9086H103.375V32.2312H102.625ZM102.625 35.8011V38.4786H103.375V35.8011H102.625ZM102.625 39.3711V40.7098H103.375V39.3711H102.625ZM102.625 40.7098C102.625 41.151 102.69 41.5776 102.812 41.98L103.53 41.7626C103.429 41.4298 103.375 41.0765 103.375 40.7098H102.625ZM103.141 42.7728C103.549 43.5343 104.175 44.1608 104.937 44.5687L105.291 43.9076C104.66 43.5695 104.14 43.0498 103.802 42.4186L103.141 42.7728ZM105.73 44.8974C106.132 45.0193 106.559 45.0848 107 45.0848V44.3348C106.633 44.3348 106.28 44.2804 105.947 44.1796L105.73 44.8974ZM107 45.0848H108.442V44.3348H107V45.0848ZM109.404 45.0848H112.288V44.3348H109.404V45.0848ZM113.25 45.0848H116.135V44.3348H113.25V45.0848ZM117.096 45.0848H119.981V44.3348H117.096V45.0848ZM120.942 45.0848H123.827V44.3348H120.942V45.0848ZM124.788 45.0848H127.673V44.3348H124.788V45.0848ZM128.635 45.0848H131.519V44.3348H128.635V45.0848ZM132.481 45.0848H135.365V44.3348H132.481V45.0848ZM136.327 45.0848H139.212V44.3348H136.327V45.0848ZM140.173 45.0848H143.058V44.3348H140.173V45.0848ZM144.019 45.0848H146.904V44.3348H144.019V45.0848ZM147.865 45.0848H150.75V44.3348H147.865V45.0848ZM151.712 45.0848H154.596V44.3348H151.712V45.0848ZM155.558 45.0848H157V44.3348H155.558V45.0848ZM157 45.0848C157.367 45.0848 157.72 45.1391 158.053 45.2399L158.27 44.5221C157.868 44.4002 157.441 44.3348 157 44.3348V45.0848ZM158.709 45.5119C159.34 45.85 159.86 46.3697 160.198 47.0009L160.859 46.6468C160.451 45.8852 159.825 45.2587 159.063 44.8508L158.709 45.5119ZM160.47 47.657C160.571 47.9897 160.625 48.3431 160.625 48.7098H161.375C161.375 48.2686 161.31 47.842 161.188 47.4395L160.47 47.657ZM160.625 48.7098V50.0495H161.375V48.7098H160.625ZM160.625 50.9426V53.622H161.375V50.9426H160.625ZM160.625 54.5152V57.1946H161.375V54.5152H160.625ZM160.625 58.0877V60.7672H161.375V58.0877H160.625ZM160.625 61.6603V63H161.375V61.6603H160.625Z",
    fill: "#4276EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_933_11603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.735 63.2652C160.881 63.4116 161.119 63.4116 161.265 63.2652L163.652 60.8787C163.798 60.7322 163.798 60.4948 163.652 60.3483C163.505 60.2019 163.268 60.2019 163.121 60.3483L161 62.4697L158.879 60.3483C158.732 60.2019 158.495 60.2019 158.348 60.3483C158.202 60.4948 158.202 60.7322 158.348 60.8787L160.735 63.2652ZM102.625 30V31.3387H103.375V30H102.625ZM102.625 32.2312V34.9086H103.375V32.2312H102.625ZM102.625 35.8011V38.4786H103.375V35.8011H102.625ZM102.625 39.3711V40.7098H103.375V39.3711H102.625ZM102.625 40.7098C102.625 41.151 102.69 41.5776 102.812 41.98L103.53 41.7626C103.429 41.4298 103.375 41.0765 103.375 40.7098H102.625ZM103.141 42.7728C103.549 43.5343 104.175 44.1608 104.937 44.5687L105.291 43.9076C104.66 43.5695 104.14 43.0498 103.802 42.4186L103.141 42.7728ZM105.73 44.8974C106.132 45.0193 106.559 45.0848 107 45.0848V44.3348C106.633 44.3348 106.28 44.2804 105.947 44.1796L105.73 44.8974ZM107 45.0848H108.442V44.3348H107V45.0848ZM109.404 45.0848H112.288V44.3348H109.404V45.0848ZM113.25 45.0848H116.135V44.3348H113.25V45.0848ZM117.096 45.0848H119.981V44.3348H117.096V45.0848ZM120.942 45.0848H123.827V44.3348H120.942V45.0848ZM124.788 45.0848H127.673V44.3348H124.788V45.0848ZM128.635 45.0848H131.519V44.3348H128.635V45.0848ZM132.481 45.0848H135.365V44.3348H132.481V45.0848ZM136.327 45.0848H139.212V44.3348H136.327V45.0848ZM140.173 45.0848H143.058V44.3348H140.173V45.0848ZM144.019 45.0848H146.904V44.3348H144.019V45.0848ZM147.865 45.0848H150.75V44.3348H147.865V45.0848ZM151.712 45.0848H154.596V44.3348H151.712V45.0848ZM155.558 45.0848H157V44.3348H155.558V45.0848ZM157 45.0848C157.367 45.0848 157.72 45.1391 158.053 45.2399L158.27 44.5221C157.868 44.4002 157.441 44.3348 157 44.3348V45.0848ZM158.709 45.5119C159.34 45.85 159.86 46.3697 160.198 47.0009L160.859 46.6468C160.451 45.8852 159.825 45.2587 159.063 44.8508L158.709 45.5119ZM160.47 47.657C160.571 47.9897 160.625 48.3431 160.625 48.7098H161.375C161.375 48.2686 161.31 47.842 161.188 47.4395L160.47 47.657ZM160.625 48.7098V50.0495H161.375V48.7098H160.625ZM160.625 50.9426V53.622H161.375V50.9426H160.625ZM160.625 54.5152V57.1946H161.375V54.5152H160.625ZM160.625 58.0877V60.7672H161.375V58.0877H160.625ZM160.625 61.6603V63H161.375V61.6603H160.625Z",
    fill: "#7DA0FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_933_11603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2652 63.2652C45.1187 63.4116 44.8813 63.4116 44.7348 63.2652L42.3484 60.8787C42.2019 60.7322 42.2019 60.4948 42.3484 60.3483C42.4948 60.2019 42.7322 60.2019 42.8787 60.3483L45 62.4697L47.1213 60.3483C47.2678 60.2019 47.5052 60.2019 47.6516 60.3483C47.7981 60.4948 47.7981 60.7322 47.6516 60.8787L45.2652 63.2652ZM103.375 30V31.3387H102.625V30H103.375ZM103.375 32.2312V34.9086H102.625V32.2312H103.375ZM103.375 35.8011V38.4786H102.625V35.8011H103.375ZM103.375 39.3711V40.7098H102.625V39.3711H103.375ZM103.375 40.7098C103.375 41.151 103.31 41.5776 103.188 41.98L102.47 41.7626C102.571 41.4298 102.625 41.0765 102.625 40.7098H103.375ZM102.859 42.7728C102.451 43.5343 101.825 44.1608 101.063 44.5687L100.709 43.9076C101.34 43.5695 101.86 43.0498 102.198 42.4186L102.859 42.7728ZM100.27 44.8974C99.8678 45.0193 99.4412 45.0848 99 45.0848V44.3348C99.3667 44.3348 99.7201 44.2804 100.053 44.1796L100.27 44.8974ZM99 45.0848H97.5577V44.3348H99V45.0848ZM96.5962 45.0848H93.7115V44.3348H96.5962V45.0848ZM92.75 45.0848H89.8654V44.3348H92.75V45.0848ZM88.9038 45.0848H86.0192V44.3348H88.9038V45.0848ZM85.0577 45.0848H82.1731V44.3348H85.0577V45.0848ZM81.2115 45.0848H78.3269V44.3348H81.2115V45.0848ZM77.3654 45.0848H74.4808V44.3348H77.3654V45.0848ZM73.5192 45.0848H70.6346V44.3348H73.5192V45.0848ZM69.6731 45.0848H66.7885V44.3348H69.6731V45.0848ZM65.8269 45.0848H62.9423V44.3348H65.8269V45.0848ZM61.9808 45.0848H59.0961V44.3348H61.9808V45.0848ZM58.1346 45.0848H55.25V44.3348H58.1346V45.0848ZM54.2885 45.0848H51.4038V44.3348H54.2885V45.0848ZM50.4423 45.0848H49V44.3348H50.4423V45.0848ZM49 45.0848C48.6333 45.0848 48.2799 45.1391 47.9472 45.2399L47.7297 44.5221C48.1322 44.4002 48.5588 44.3348 49 44.3348V45.0848ZM47.2911 45.5119C46.66 45.85 46.1402 46.3697 45.8022 47.0009L45.141 46.6468C45.5489 45.8852 46.1755 45.2587 46.937 44.8508L47.2911 45.5119ZM45.5301 47.657C45.4293 47.9897 45.375 48.3431 45.375 48.7098H44.625C44.625 48.2686 44.6904 47.842 44.8124 47.4395L45.5301 47.657ZM45.375 48.7098V50.0495H44.625V48.7098H45.375ZM45.375 50.9426V53.622H44.625V50.9426H45.375ZM45.375 54.5152V57.1946H44.625V54.5152H45.375ZM45.375 58.0877V60.7672H44.625V58.0877H45.375ZM45.375 61.6603V63H44.625V61.6603H45.375Z",
    fill: "#24A5A8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_933_11603)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 45,
    r: 9,
    stroke: "#7DA0FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 45,
    r: 9,
    stroke: "#4276EF",
    strokeWidth: 0.6,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 45,
    r: 7,
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_933_11603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.458 44.7917L137.625 45.625L136.792 44.7917M137.727 45.4167C137.742 45.2799 137.75 45.1408 137.75 45C137.75 42.9289 136.071 41.25 134 41.25C131.929 41.25 130.25 42.9289 130.25 45C130.25 47.0711 131.929 48.75 134 48.75C135.178 48.75 136.229 48.2068 136.917 47.3572M134 42.9167V45L135.25 45.8333",
    stroke: "#394353",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_933_11603)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 45,
    r: 9,
    stroke: "#24A5A8",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 45,
    r: 9,
    stroke: "#3DC3C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 45,
    r: 7,
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_933_11603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.499 45L71.999 42.5L74.499 45L71.999 47.5L69.499 45Z",
    fill: "#394353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.999 41.2461C72.7407 41.2461 73.4657 41.466 74.0824 41.8781C74.6991 42.2901 75.1797 42.8758 75.4636 43.561C75.7474 44.2463 75.8217 45.0003 75.677 45.7277C75.5323 46.4551 75.1751 47.1233 74.6507 47.6477C74.1262 48.1722 73.458 48.5293 72.7306 48.674C72.0032 48.8187 71.2492 48.7445 70.564 48.4606C69.8787 48.1768 69.2931 47.6962 68.881 47.0795C68.469 46.4628 68.249 45.7378 68.249 44.9961C68.2502 44.0019 68.6456 43.0487 69.3487 42.3457C70.0517 41.6427 71.0048 41.2473 71.999 41.2461ZM71.999 40.6211C71.1337 40.6211 70.2879 40.8777 69.5684 41.3584C68.8489 41.8391 68.2882 42.5224 67.9571 43.3219C67.6259 44.1213 67.5393 45.0009 67.7081 45.8496C67.8769 46.6983 68.2936 47.4778 68.9054 48.0897C69.5173 48.7015 70.2968 49.1182 71.1455 49.287C71.9942 49.4558 72.8738 49.3692 73.6733 49.0381C74.4727 48.7069 75.156 48.1462 75.6367 47.4267C76.1174 46.7072 76.374 45.8614 76.374 44.9961C76.374 43.8358 75.9131 42.723 75.0926 41.9025C74.2721 41.082 73.1593 40.6211 71.999 40.6211Z",
    fill: "#394353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_933_11603",
    x: 44,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_933_11603",
    result: "effect2_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_933_11603",
    result: "effect3_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_933_11603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_933_11603",
    x: 0,
    y: 57,
    width: 103,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_933_11603",
    result: "effect2_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_933_11603",
    result: "effect3_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_933_11603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_933_11603",
    x: 103,
    y: 57,
    width: 103,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_933_11603",
    result: "effect2_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_933_11603",
    result: "effect3_dropShadow_933_11603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_933_11603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_933_11603",
    x: 90.625,
    y: 18,
    width: 85.1367,
    height: 57.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_933_11603"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_933_11603",
    x: 30.2383,
    y: 18,
    width: 85.1367,
    height: 57.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_933_11603"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_933_11603",
    x: 119.625,
    y: 30.625,
    width: 28.75,
    height: 28.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_933_11603"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_933_11603",
    x: 59.625,
    y: 32.625,
    width: 24.75,
    height: 24.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_933_11603"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_933_11603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(129 40)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_933_11603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(67 40)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitUntilNode);
export default __webpack_public_path__ + "static/media/waitUntilNode.6cacad003de3f1e4904545921673f256.svg";
export { ForwardRef as ReactComponent };